export enum ManualAdditionalPages {
  PersonalDataPolicy = 'personal-data-policy',
  PersonalDataConsent = 'personal-data-consent',
}
